import { supabase } from './client';
import { supabaseUrl, supabaseAnonKey } from './config';
import { ASSISTANT_MODULES, canOpenAssistantRoute } from '../local/localAssistantAccess';

export const isManualAiConfigured = (url = supabaseUrl) => [
  'https://hxazmubxwflkikeyjvit.supabase.co',
  'https://suhprttgrhyaxnqykkht.supabase.co',
].includes(url);
const failure = (message, status) => Object.assign(new Error(message), { status });

export async function requestManualAssistant({ question, pathname, history = [], access, signal }) {
  if (!isManualAiConfigured()) throw failure('La IA no esta disponible en este entorno.', 403);
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  if (signal?.aborted) abort();
  let timeout;
  const deadline = new Promise((_, reject) => {
    timeout = setTimeout(() => { abort(); reject(failure('La IA tardo demasiado.', 503)); }, 45000);
  });
  try {
    return await Promise.race([deadline, (async () => {
      const { data, error } = await supabase.auth.getSession();
      if (controller.signal.aborted) throw Object.assign(new Error('Consulta cancelada.'), { name: 'AbortError' });
      if (error || !data?.session?.access_token) throw failure('Volve a iniciar sesion para consultar la IA.', 401);
      const response = await fetch(`${supabaseUrl}/functions/v1/internal-manual-assistant`, {
        method: 'POST', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', apikey: supabaseAnonKey,
          Authorization: `Bearer ${data.session.access_token}` },
        body: JSON.stringify({ question, screen: pathname, branchId: access.branchId,
          modules: access.modules, actions: access.actions,
          history: history.filter((message) => message.id !== 'welcome' && ['user', 'assistant'].includes(message.role))
            .slice(-10).map(({ role, text }) => ({ role, text: String(text || '').slice(0, 3500) })),
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok) throw failure(result?.error || 'No pudimos consultar la IA.', response.status);
      if (typeof result?.answer !== 'string' || !result.answer.trim() || result.sourceKind !== 'manual-ai' ||
          !Array.isArray(result.sources) || !Array.isArray(result.actions)) throw failure('Respuesta incompleta.', 502);
      return { ...result,
        sources: result.sources.filter((source) => typeof source?.title === 'string').slice(0, 3),
        actions: result.actions.flatMap((action) => {
          const module = ASSISTANT_MODULES.find((entry) => entry.key === action.moduleKey && entry.route === action.route);
          return module && canOpenAssistantRoute(module.route, access) ? [{ route: module.route, label: `Abrir ${module.title}` }] : [];
        }),
        suggestedQuestions: (Array.isArray(result.suggestedQuestions) ? result.suggestedQuestions : [])
          .filter((text) => typeof text === 'string' && text.trim() && text.length <= 180).slice(0, 3),
      };
    })()]);
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener('abort', abort);
  }
}
